import CurrentCaseRequired from "../components/ui/current-case-required.js";
import ChatbotComponent from "../components/ui/ChatbotComponent.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";
import ChatInterface from "../components/ui/ChatInterface.js";

export default function ChatPage(props) {
    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
        <ChatInterface/>
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}